import { createSelector } from '@ngrx/store';
import { selectFeatureSubscription } from 'src/app/store/app.selectors';
import { SubscriptionState } from './subscription.reducer';

export const selectSubscriptionPlans = createSelector(
  selectFeatureSubscription,
  (state: SubscriptionState) => state.subscriptionPlans
);

/**
 * Select a reference to currently selected Client's Subscription object.
 * This object is fetched once when selected Client changes on the Auth layer;
 * components beyond Auth may expect Subscription to always have a valid value
 *
 * @see /shared/subscription/subscription.guard.ts
 */
export const selectSubscription = createSelector(
  selectFeatureSubscription,
  (state: SubscriptionState) => state.subscription
);
